import en from './account.en';

const enConfig = { en };

export default enConfig;
